import DocumentSvgComponent from "@assets/svg-components/document";
import DownloadSvgComponent from "@assets/svg-components/download";
import ReportsSvgComponent from "@assets/svg-components/sidebar/reports";
import ViolationSvgComponent from "@assets/svg-components/violation";
import { getColorStyle, getSingleColor } from "@common/color";
import { convertCurrentDate } from "@common/date-helpers";
import {
  concatString,
  formatAmount,
  formatText,
  getFirstLetterOfEachString,
} from "@common/text-helpers";
import ProfileCircle from "@components/ProfileCircle";
import { getValue } from "@utils/lodash";
import { Tooltip } from "react-tooltip";

function ReportsTable(props: any) {
  // Function to get dynamic approval status label
  const getDynamicApprovalStatusLabel = (item: any) => {
    const approvalStatus = getValue(item, `approval_status`, "");

    if (approvalStatus !== "awaiting_approval") {
      return { mainLabel: formatText(approvalStatus), subLabel: "" };
    }

    const approvers = getValue(item, `approvers`, []);

    if (approvers.length === 0) {
      return { mainLabel: formatText(approvalStatus), subLabel: "" };
    }

    // Filter approvers with awaiting_approval status
    const awaitingApprovers = approvers.filter(
      (approver: any) =>
        getValue(approver, `approval_status`, "") === "awaiting_approval"
    );

    if (awaitingApprovers.length === 0) {
      return { mainLabel: formatText(approvalStatus), subLabel: "" };
    }

    const sortedApprovers = awaitingApprovers.sort((a: any, b: any) => {
      const levelA = getValue(a, `approval_level`, 0);
      const levelB = getValue(b, `approval_level`, 0);
      return levelA - levelB;
    });

    const firstApprover = sortedApprovers[0];
    const approvalType = getValue(
      firstApprover,
      `approval_type`,
      ""
    ).toLowerCase();

    let subLabel = "";
    switch (approvalType) {
      case "submits_to":
        subLabel = "Reporting Manager";
        break;

      case "project_head":
        subLabel = "Project Head";
        break;

      case "manual_approver":
        subLabel = "Manual Approver";
        break;

      case "department_head_logged_in_user":
        const departmentName = getValue(
          firstApprover,
          `approver.department.department_name`,
          ""
        );
        subLabel = departmentName
          ? `${departmentName} Team`
          : "Department Head";
        break;

      default:
        subLabel = "";
    }

    return { mainLabel: "Awaiting Approval", subLabel };
  };

  return (
    <div>
      <div>
        <table className="datatable_table">
          <thead className="datatable_table_thead">
            <th className="datatable_table_th" style={{ width: "70px" }}></th>
            <th className="datatable_table_th">
              <h6 className="">Report ID</h6>
              <p className="">Submitted On</p>
            </th>
            <th className="datatable_table_th">
              <h6 className="">Employee ID</h6>
            </th>
            <th className="datatable_table_th">
              <h6 className="">Report Name</h6>
            </th>
            <th className="datatable_table_th">
              <h6 className="">Total</h6>
            </th>
            <th className="datatable_table_th">
              <h6 className="">Submitted by</h6>
            </th>
            <th className="datatable_table_th">
              <h6 className="">Approval Status</h6>
            </th>
            <th className="datatable_table_th">
              <h6 className="">Action</h6>
            </th>
          </thead>
          <tbody className="datatable_table_tbody">
            {getValue(props, `list`, []).map((item: any, index: number) => {
              console.log(item, "item");
              const statusLabels = getDynamicApprovalStatusLabel(item);

              return (
                <tr key={index} className="datatable_table_tr">
                  <td className="datatable_table_td" style={{ width: "70px" }}>
                    <ReportsSvgComponent
                      color={getSingleColor(
                        getValue(item, `approval_status`, "")
                      )}
                      size={24}
                    />
                  </td>
                  <td
                    className="datatable_table_td align-items-center"
                    onClick={() =>
                      props.handleNavigate(getValue(item, `id`, ""))
                    }
                  >
                    <div className="d-flex">
                      <div>
                        <h6 className="header_text color_primary">
                          {getValue(item, `report_id`, "")}
                        </h6>
                        <p className="small_text">
                          {/* {convertDate(getValue(item, `submitted_at`, ""))} */}
                          {convertCurrentDate(
                            getValue(item, `submitted_at`, "")
                          )}
                        </p>
                      </div>
                    </div>
                  </td>
                  <td
                    onClick={() =>
                      props.handleNavigate(getValue(item, `id`, ""))
                    }
                    className={`datatable_table_td`}
                  >
                    <h6 className="">
                      {getValue(item, `created_by.employee_id`, "")}
                    </h6>
                  </td>
                  <td
                    className="datatable_table_td"
                    onClick={() =>
                      props.handleNavigate(getValue(item, `id`, ""))
                    }
                  >
                    <h6 className="">
                      {concatString(getValue(item, `report_name`, ""), 30)}
                    </h6>
                  </td>
                  <td
                    onClick={() =>
                      props.handleNavigate(getValue(item, `id`, ""))
                    }
                    className={`datatable_table_td`}
                  >
                    <h6 className="">
                      {getValue(item, `currency_symbol`, "")}{" "}
                      {formatAmount(getValue(item, `total`, ""))}
                    </h6>
                  </td>
                  <td
                    className="datatable_table_td"
                    onClick={() =>
                      props.handleNavigate(getValue(item, `id`, ""))
                    }
                  >
                    {getValue(item, `created_by.email`, "") ? (
                      <div className="d-flex align-items-center">
                        <ProfileCircle
                          name="created_by"
                          item={item}
                          value={getValue(item, `created_by.first_name`, "")}
                        />
                        <div>
                          <h6>
                            {" "}
                            {getValue(item, `created_by.first_name`, "")}{" "}
                            {getValue(item, `created_by.middle_name`, "")}{" "}
                            {getValue(item, `created_by.last_name`, "")}
                          </h6>
                          <p>{getValue(item, `created_by.email`, "")}</p>
                        </div>
                      </div>
                    ) : (
                      <p className="text-center ms-5">-</p>
                    )}
                  </td>
                  <td
                    className="datatable_table_td"
                    onClick={() =>
                      props.handleNavigate(getValue(item, `id`, ""))
                    }
                    style={{ minWidth: "180px" }}
                  >
                    <div>
                      <h6
                        className=""
                        style={{
                          ...getColorStyle(
                            getValue(item, `approval_status`, "")
                          ),
                          whiteSpace: "nowrap",
                          lineHeight: "1.3",
                          fontSize: "0.875rem",
                        }}
                      >
                        {statusLabels.mainLabel}
                      </h6>
                      {statusLabels.subLabel && (
                        <p className="small_text ms-2">
                          {statusLabels.subLabel}
                        </p>
                      )}
                    </div>
                  </td>
                  <td className="datatable_table_td">
                    <div className="d-flex align-items-center">
                      <div
                        data-tooltip-id={
                          getValue(item, `receipts.length`, 0) > 0
                            ? "my-tooltip-document"
                            : ""
                        }
                        data-tooltip-content="This expense contains receipts"
                      >
                        <DocumentSvgComponent
                          color={
                            getValue(item, `receipts.length`, 0) > 0
                              ? "#276EF1"
                              : "lightgray"
                          }
                        />
                      </div>
                      <div
                        data-tooltip-id={
                          !getValue(
                            item,
                            `expense_entries[${0}].is_policy_violated`,
                            false
                          )
                            ? ""
                            : "my-tooltip"
                        }
                        data-tooltip-content="This expense violated certain policies"
                        className={`mx-2`}
                      >
                        <ViolationSvgComponent
                          color={
                            getValue(
                              item,
                              `expense_entries[${0}].is_policy_violated`,
                              false
                            )
                              ? "#ff8a00"
                              : "lightgray"
                          }
                          size={20}
                        />
                      </div>

                      <div
                        data-tooltip-id={"my-tooltip-reports-download"}
                        data-tooltip-content={
                          getValue(props, "downloadingReportId", null) ===
                          getValue(item, "id", "")
                            ? "Preparing download..."
                            : "Summarized Pdf"
                        }
                        className={`${
                          getValue(props, "downloadingReportId", null) ===
                          getValue(item, "id", "")
                            ? "pe-none opacity-75"
                            : "cursor-pointer"
                        }`}
                        onClick={() => {
                          if (
                            getValue(props, "downloadingReportId", null) !==
                            getValue(item, "id", "")
                          ) {
                            props.handleDownload(getValue(item, `id`, ""));
                          }
                        }}
                      >
                        {getValue(props, "downloadingReportId", null) ===
                        getValue(item, "id", "") ? (
                          <div
                            className="spinner-border spinner-border-sm text-primary"
                            role="status"
                            aria-label="Preparing summarized PDF"
                          />
                        ) : (
                          <DownloadSvgComponent color={"lightgray"} size={20} />
                        )}
                      </div>
                      <div
                        data-tooltip-id={"my-tooltip-reports-download"}
                        data-tooltip-content={
                          getValue(props, "downloadingZipReportId", null) ===
                          getValue(item, "id", "")
                            ? "Preparing download..."
                            : "Attachments Zip"
                        }
                        className={`ms-2 ${
                          getValue(props, "downloadingZipReportId", null) ===
                          getValue(item, "id", "")
                            ? "pe-none opacity-75"
                            : "cursor-pointer"
                        }`}
                        onClick={() => {
                          if (
                            getValue(props, "downloadingZipReportId", null) !==
                            getValue(item, "id", "")
                          ) {
                            props.handleZipAttachmentsDownload(
                              getValue(item, `id`, "")
                            );
                          }
                        }}
                      >
                        {getValue(props, "downloadingZipReportId", null) ===
                        getValue(item, "id", "") ? (
                          <div
                            className="spinner-border spinner-border-sm text-primary"
                            role="status"
                            aria-label="Preparing attachments zip"
                          />
                        ) : (
                          <DownloadSvgComponent color={"lightgray"} size={20} />
                        )}
                      </div>
                    </div>
                  </td>
                  {/* <td className="datatable_table_td">
                  <div className="more-dropdown">
                    <UncontrolledDropdown>
                      <DropdownToggle>
                        <div className="switch_header__dropdown m-0">
                          <div className="dropdown-content d-flex cursor-pointer">
                            <img
                              src="/images/more.svg"
                              width="24px"
                              height="24px"
                              className="img-fluid"
                            />
                          </div>
                        </div>
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem
                          onClick={() =>
                            props.handleNavigate(getValue(item, `id`, ""))
                          }
                        >
                          <div className={`more-dropdown-item `}>
                            <p>Edit</p>
                          </div>
                        </DropdownItem>
                        <DropdownItem
                          onClick={() =>
                            props.sendInviteUser(getValue(item, `id`, ""))
                          }
                        >
                          <div className={`more-dropdown-item `}>
                            <p>View</p>
                          </div>
                        </DropdownItem>
                        <DropdownItem
                          onClick={() =>
                            props.handleDeleteFun(
                              getValue(item, `id`, ""),
                              getValue(item, `title`, "")
                            )
                          }
                        >
                          <div className={`more-dropdown-item `}>
                            <p>Delete</p>
                          </div>
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </div>
                </td> */}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <Tooltip id="my-tooltip" place="bottom" />
      <Tooltip id="my-tooltip-document" place="bottom" />
      <Tooltip id="my-tooltip-reports-download" place="bottom" />
    </div>
  );
}

export default ReportsTable;
